import { ClientResources, PersonDto } from '@app/api2/api';
import * as yup from 'yup';
import { BiographicalSchema } from './Tabs/BiographicalTab.Schema';
import { AdditionalSchema } from './Tabs/AdditionalTab.Schema';
import { EmploymentSchema } from './Tabs/ProfessionalTab.Schema';
import { ContactSchema } from './Tabs/ContactTab.Schema';
import { IdentificationSchema } from './Tabs/IdentificationTab.Schema';
import { PhysicalSchema } from './Tabs/PhysicalTab.Schema';

export const PersonValidationSchema: (t: ClientResources) => yup.SchemaOf<PersonDto> = (t) =>
    BiographicalSchema(t)
    .concat(EmploymentSchema(t))
    .concat(AdditionalSchema(t))
    .concat(ContactSchema(t))
    .concat(IdentificationSchema(t))
    .concat(PhysicalSchema(t));

export const PersonSearchValidationSchema = (t: ClientResources) => yup.object().shape({
    biographical: yup.array().of(BiographicalSchema(t)).label('Biographical'),
    employment: yup.array().of(EmploymentSchema(t)).label('Employment'),
    additional: yup.array().of(AdditionalSchema(t)).label('Additional'),
    contact: yup.array().of(ContactSchema(t)).label('Contact'),
    identification: yup.array().of(IdentificationSchema(t)).label('Identification'),
    physical: yup.array().of(PhysicalSchema(t)).label('Physical'),
});
